var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tab",staticClass:"c-perk-tab"},[_c('PerkPointLabel'),_vm._l((_vm.perks),function(perk,i){return _c('PerkButton',{key:i,attrs:{"perk":perk}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }